import styled from 'styled-components';
import { spacer12 } from '@spotify-internal/encore-foundation';
export default styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1dmlgxz-0"
})(["padding-top:", ";padding-bottom:", ";min-width:0;"], spacer12, spacer12);